import _slicedToArray from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React, { useState, useEffect } from 'react';
import { useMove, clampUseMovePosition } from '@mantine/hooks';
import { Thumb } from '../Thumb/Thumb.js';
import useStyles from './Saturation.styles.js';
import { convertHsvaTo } from '../converters/converters.js';

function Saturation(_ref) {
  var value = _ref.value,
      onChange = _ref.onChange,
      _ref$focusable = _ref.focusable,
      focusable = _ref$focusable === void 0 ? true : _ref$focusable,
      _ref$__staticSelector = _ref.__staticSelector,
      __staticSelector = _ref$__staticSelector === void 0 ? "saturation" : _ref$__staticSelector,
      size = _ref.size,
      color = _ref.color,
      saturationLabel = _ref.saturationLabel,
      classNames = _ref.classNames,
      styles = _ref.styles;

  var _useStyles = useStyles({
    size: size
  }, {
    classNames: classNames,
    styles: styles,
    name: __staticSelector
  }),
      classes = _useStyles.classes;

  var _useState = useState({
    x: value.s / 100,
    y: 1 - value.v / 100
  }),
      _useState2 = _slicedToArray(_useState, 2),
      position = _useState2[0],
      setPosition = _useState2[1];

  var _useMove = useMove(function (_ref2) {
    var x = _ref2.x,
        y = _ref2.y;
    onChange({
      s: Math.round(x * 100),
      v: Math.round((1 - y) * 100)
    });
  }),
      ref = _useMove.ref;

  useEffect(function () {
    setPosition({
      x: value.s / 100,
      y: 1 - value.v / 100
    });
  }, [value.s, value.v]);

  var handleArrow = function handleArrow(event, pos) {
    event.preventDefault();

    var _position = clampUseMovePosition(pos);

    onChange({
      s: Math.round(_position.x * 100),
      v: Math.round((1 - _position.y) * 100)
    });
  };

  var handleKeyDown = function handleKeyDown(event) {
    switch (event.nativeEvent.code) {
      case "ArrowUp":
        {
          handleArrow(event, {
            y: position.y - 0.05,
            x: position.x
          });
          break;
        }

      case "ArrowDown":
        {
          handleArrow(event, {
            y: position.y + 0.05,
            x: position.x
          });
          break;
        }

      case "ArrowRight":
        {
          handleArrow(event, {
            x: position.x + 0.05,
            y: position.y
          });
          break;
        }

      case "ArrowLeft":
        {
          handleArrow(event, {
            x: position.x - 0.05,
            y: position.y
          });
          break;
        }
    }
  };

  return /* @__PURE__ */React.createElement("div", {
    className: classes.saturation,
    ref: ref,
    role: "slider",
    "aria-label": saturationLabel,
    "aria-valuenow": position.x,
    "aria-valuetext": convertHsvaTo("rgba", value),
    tabIndex: focusable ? 0 : -1,
    onKeyDown: handleKeyDown
  }, /* @__PURE__ */React.createElement("div", {
    className: classes.saturationOverlay,
    style: {
      backgroundColor: "hsl(".concat(value.h, ", 100%, 50%)")
    }
  }), /* @__PURE__ */React.createElement("div", {
    className: classes.saturationOverlay,
    style: {
      backgroundImage: "linear-gradient(90deg, #fff, transparent)"
    }
  }), /* @__PURE__ */React.createElement("div", {
    className: classes.saturationOverlay,
    style: {
      backgroundImage: "linear-gradient(0deg, #000, transparent)"
    }
  }), /* @__PURE__ */React.createElement(Thumb, {
    __staticSelector: __staticSelector,
    classNames: classNames,
    styles: styles,
    position: position,
    className: classes.saturationThumb,
    style: {
      backgroundColor: color
    },
    size: size
  }));
}

Saturation.displayName = "@mantine/core/Saturation";
export { Saturation };